import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { task } from 'ember-concurrency';

class ItuneImportSettings {
  id = 0;
  recordType = 'tool-itunes-import';
  @tracked upc = '';
}

export default class AdminToolItunesImport extends Controller {
  // Service
  @service fetch;
  @service flashMessages;
  @service confirm;
  @service headData;
  @service intl;

  // Deafaults
  ituneImportSettings = new ItuneImportSettings();

  // Getters and setters
  get isDisabled() {
    return this.importProduct.isRunning || !this.ituneImportSettings.upc;
  }

  // Actions
  setHeadData = () => {
    this.headData.title = this.intl.t('tool_itunes_import.headline');
    this.headData.favicon = 'tool-itunes-import';
  };

  // Functions
  handleError(response, upc) {
    let scope = 'tool_itunes_import.error';
    let message = this.intl.t(`${scope}.default`);

    if (response.messages && response.messages.length > 0) {
      message = this.intl.t(`${scope}.not_found`, { product: upc });
    }

    this.flashMessages.error(message, { rawString: true, sticky: true });
  }

  async handleSuccess(response) {
    let { update } = response.product;
    let scope = 'tool_itunes_import.success';
    const message = update ? `${scope}.updated` : `${scope}.added`;

    this.flashMessages.success(message);
  }

  // Tasks
  importProduct = task({ maxConcurrency: 3, enqueue: true }, async () => {
    try {
      let upc = this.ituneImportSettings.upc;
      let response = await this.fetch.request(`/products/itunes/${upc}`);
      this.upc = undefined;

      if (!response.product) this.handleError(response, upc);
      else this.handleSuccess(response);
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  });
}
